import axios from "../../api/axios";
import { useRef, useState, useEffect, FormEvent } from "react";
import IUser from "../../models/User";
import useAuth from "../../hooks/UseAuth";
import { useNavigate , useLocation } from 'react-router-dom';

const LOGIN_URL = '/api/hbscan/login';
const USER_URL = 'api/hbscan/getuser';

const handleError = (err: any, errorCallback: Function) => {
    if (!err?.response) {
        errorCallback('Server not responding');
        return;
    }

    switch(err.response?.status){
        case 400:
            errorCallback("Wrong email or password");
            break;
        case 401:
            errorCallback("Unauthorized");
            break;
        default:
            errorCallback('Login Failed');
    }
}

const saveUser = async (guid : string, successCallback : Function) => {
    const response = await axios.get(`${USER_URL}/${guid}`);
    const data = response?.data;
    const user: IUser = {
        guid: guid,
        name: data.name, 
        email: data.email, 
        tenantId : data.tenantId, 
        companyId: data.companyId, 
        role : data.role
    }
    successCallback(user);
}

type stateType = {
    from: { pathname: string }
}


const UseLogin = () => {
    const {setAuth} = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const from = (location.state as stateType)?.from?.pathname || "dashboard";

    const userRef = useRef<HTMLInputElement>(null);
    const errRef = useRef<HTMLParagraphElement>(null);

    const [username, setUsername] = useState('');
    const [pwd, setPwd] = useState('');
    const [errMsg, setErrMsg] = useState('');

    useEffect( () => {
        userRef.current?.focus();
    },[]);

    useEffect( () => {
        setErrMsg('');
    }, [username,pwd]);

    const handleSubmit = async (e:FormEvent) => {
        e.preventDefault();
        const errorCallback = (error: string) => {
            setErrMsg(error);
            errRef.current?.focus();
        }

        try{
            const response = await axios.post(
                LOGIN_URL, 
                JSON.stringify({"email": username,"password": pwd}),
                {headers: {'Content-Type': 'application/json'}}
            );
            const guid = response?.data?.guid;
            const successCallback =(user: IUser) => {setAuth(user);setUsername('');setPwd('');navigate(from,{replace: true})}
            await saveUser(guid,successCallback);
        }catch(err: any){
            handleError(err, errorCallback);
        }
    }

    return {
        username,
        setUsername,
        pwd,
        setPwd,
        errMsg,
        userRef,
        errRef,
        handleSubmit
    }
}

export default UseLogin;